import { Box, Container, Typography, Grid, Link, IconButton } from "@mui/material"
import { Phone, Email, LocationOn, Facebook, LinkedIn, Twitter, YouTube } from "@mui/icons-material"

const quickLinks = ["About Us", "ThoughtCoCreate", "EduCatalyst", "EduCommunity"]

const contactInfo = [
  { icon: <Phone />, text: "+60 166 613 878", href: "tel:+60166613878" },
  { icon: <Email />, text: "contact@pythaverse.net", href: "mailto:contact@pythaverse.net" },
  {
    icon: <LocationOn />,
    text: "18 Sin Ming Lane, #07-25\nMid View City, Singapore 573960",
    href: "https://www.google.com/maps/search/?api=1&query=18+Sin+Ming+Lane,+%2307-25+Mid+View+City,+Singapore+573960",
  },
]

const socialLinks = [
  { icon: <Facebook />, label: "Facebook" },
  { icon: <LinkedIn />, label: "LinkedIn" },
  { icon: <Twitter />, label: "Twitter" },
  { icon: <YouTube />, label: "YouTube" },
]

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "#ccc",
        py: 8,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4} sx={{ mb: 5 }}>
          <Grid item xs={12} md={6} lg={4}>
            <Typography
              variant="h6"
              sx={{
                fontSize: "1.4rem",
                fontWeight: 900,
                color: "white",
                mb: 2,
              }}
            >
              PYTHAVERSE PTE LTD.
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
              The complete EcoSystem for educator growth, designed to foster innovation, collaboration, and professional
              development.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <Typography
              variant="h6"
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "1rem",
                mb: 3,
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              Quick Links
            </Typography>
            <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
              {quickLinks.map((link, index) => (
                <Box component="li" key={index} sx={{ mb: 1 }}>
                  <Link
                    href="#"
                    sx={{
                      color: "#ccc",
                      textDecoration: "none",
                      "&:hover": { color: "white" },
                    }}
                  >
                    {link}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Typography
              variant="h6"
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "1rem",
                mb: 3,
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              Contact Us
            </Typography>
            <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
              {contactInfo.map((contact, index) => (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    mb: 1,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                  }}
                >
                  <Box sx={{ mt: 0.5, fontSize: "1rem" }}>{contact.icon}</Box>
                  <Link
                    href={contact.href}
                    target={contact.href.includes("maps") ? "_blank" : undefined}
                    rel={contact.href.includes("maps") ? "noopener noreferrer" : undefined}
                    sx={{
                      color: "#ccc",
                      textDecoration: "none",
                      whiteSpace: "pre-line",
                      "&:hover": { color: "white" },
                    }}
                  >
                    {contact.text}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={12} lg={3}>
            <Typography
              variant="h6"
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "1rem",
                mb: 3,
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              Follow Us
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  href="#"
                  aria-label={social.label}
                  sx={{
                    color: "#ccc",
                    fontSize: "1.4rem",
                    "&:hover": { color: "white" },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            textAlign: "center",
            pt: 3,
            mt: 5,
            borderTop: "1px solid #00599a",
            fontSize: "0.85rem",
          }}
        >
          © 2025 Pythaverse. All Rights Reserved.
        </Box>
      </Container>
    </Box>
  )
}
